export default class ContactFormAnalytics {
  constructor() {}

  static init() {
    /** @type {HTMLButtonElement | null} */
    const contactFormSubmitButton = document.querySelector('form.contact-form p.contact-submit button[type="submit"]');

    if (!contactFormSubmitButton) {
      return;
    }

    contactFormSubmitButton.addEventListener('click', (_event) => {
      ContactFormAnalytics.handleSuccessMessageAnalytics();
    });
  }

  /**
   * @summary Use this function as a hook for successful contact form submissions.
   * Call this function where you know the submission is successful, and it will take care of the analytics fields.
   * @returns {void}
   */
  static handleSuccessMessageAnalytics() {
    if (
      window.codexData
      && typeof createSerializationId === 'function'
      && typeof getRandomAlphanumericAsciiId === 'function'
      && typeof satelliteTrack === 'function'
      && !ContactFormAnalytics.doesFormHaveErrorsSummary()
    ) {
      // Get the app name from the codexData object, otherwise use `'corus'` as a default.
      const namePrefix = window?.codexData?.app?.name ?? 'corus';
  
      // Get the 2-letter app ID from the codexData object, otherwise use `'CE'` as a default.
      const idPrefix = window?.codexData?.misc?.serializationIdPrefix ?? 'CE';
  
      const oldCodexData = window.codexData;

      const flowNameSuffix = ContactFormAnalytics.getflowNameSuffix();
  
      const newCodexData = {
        ...oldCodexData,
        events: {
          flowComplete: true,
          flowStep: true,
          view: false, // form submission is not a page view
        },
        flow: {
          name: `${namePrefix}-${flowNameSuffix}`,
          serializationid: createSerializationId(
            idPrefix,
            getRandomAlphanumericAsciiId(4),
            Date.now(),
          ),
          stepName: 'complete',
        },
      };
  
      window.codexData = newCodexData;
  
      satelliteTrack();
    }
  }

  /**
   * Get the suffix for the `flow.name` field by collecting it from encoded JSON on an element of the form
   * `<div data-contact-form-analytics='{"flowNameSuffix":"foo"}' />`.
   *
   * If this value cannot be found or if there is an issue parsing it, this function returns just `'form'`.
   * @returns {string}
   */
  static getflowNameSuffix() {
    const defaultValue = 'form';

    /** @type {HTMLElement | null} */
    const contactFormAnalyticsMetadataElement = document.querySelector('*[data-contact-form-analytics]');

    if (!contactFormAnalyticsMetadataElement) {
      return defaultValue;
    }

    const contactFormAnalyticsMetadata = contactFormAnalyticsMetadataElement.dataset?.['contactFormAnalytics'];

    if (!contactFormAnalyticsMetadata) {
      return defaultValue;
    }

    let data = {};

    try {
      data = JSON.parse(contactFormAnalyticsMetadata);
    } catch (_err) {
      return defaultValue;
    }

    return data?.['flowNameSuffix'] ?? defaultValue;
  }

  /**
   * Does the Contact Form have an errors summary container indicating errors?
   * Also checks that the container is not empty as the element may still be present but empty if the user fixes the errors.
   * @returns {boolean}
   */
  static doesFormHaveErrorsSummary() {
    const contactFormErrorsSummaryElement = document.querySelector('div.contact-form__error');

    return contactFormErrorsSummaryElement && contactFormErrorsSummaryElement.hasChildNodes();
  }
}
